import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Palmtree, X } from "lucide-react";

const fmt = (iso) => {
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" }).format(
      new Date(`${iso}T12:00:00`)
    );
  } catch {
    return iso;
  }
};

export default function AbsenceBanner({ start, end }) {
  const [dismissed, setDismissed] = useState(false);

  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.4 }}
          className="px-4 pt-24 sm:px-6 lg:px-8"
          data-testid="absence-banner"
        >
          <div className="mx-auto flex max-w-3xl items-center gap-3 rounded-2xl bg-amber-100 px-5 py-4 ring-1 ring-amber-200">
            <Palmtree className="h-6 w-6 shrink-0 text-amber-700" />
            <p className="flex-1 text-sm leading-relaxed text-amber-900 sm:text-base">
              <strong>En congés{start && end ? ` du ${fmt(start)} au ${fmt(end)}` : ""}.</strong>{" "}
              Les réservations restent ouvertes pour mon retour — je confirmerai chaque rendez-vous par téléphone.
            </p>
            <button
              onClick={() => setDismissed(true)}
              aria-label="Fermer le message"
              data-testid="absence-dismiss"
              className="rounded-full p-1.5 text-amber-700 transition-colors hover:bg-amber-200"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
